import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
    
      <p class="mb-3">
        Когда мы прилетели на эту планету, здесь были только леса, и в них насекомые. 
        Гигантские стрекозы, бабочки, кузнечики, по размерам как раз подходящие к этим деревьям. 
        Они сидели на них, как у нас эолки на крунгах. 
      </p>
      
      <p class="mb-3">
        Вполне себе цивилизация, с богатым видовым разнообразием и более или менее установившемся биологическим равновесием. 
        В общем, нам, космической экополиции и экоконтролю, делать здесь было нечего. 
        Всё развивалось нормально, как и должно было быть. 
        Через пару сотен миллионов лет у насекомых должен был появиться разум, и процветание планеты было обеспечено.
      </p>
      
      <p class="mb-3">
        Но скучно на этом свете, господа! Чего мы сюда летели, тратили казённые средства? 
        Если тут нечего делать – так и премию нам не дадут; а лететь на край света и возвращаться не солоно хлебавши, без премии и без дела, 
        вновь месяцами предаваясь бесконечной космической скуке?
      </p>
      
      <p class="mb-3">
        Вот эта скука, испытанная на пути сюда, здесь, и ожидаемая ещё более невыносимой на обратном пути, и заставила нас сыграть тут шутку. 
        Именно шутку, чтобы развеять скуку.
      </p>
      
      <p class="mb-3">
        Мы решили немного подправить эволюцию, обогатить биоразнообразие – словом, ничего плохого, ничего против правил. 
        Просто добавить зародыш ещё одного вида, чтоб веселее было жить. 
        И нам, и им (впоследствии😁). 
        Процедура, разрешённая на вымирающих планетах; ну а кто докажет, что эта планета не вымирающая? 
        Раз мы здесь были, сюда уже никто не залетит: Космос ведь бесконечен, и планет в нём…
      </p>
      
      <p class="mb-3">
        И от той же бескрайней скуки мы решили немножко поколдовать над будущим зародышем, сделав его гибридом нескольких разных типов: 
        теплокровным, чтобы  конкурировал с насекомыми, но двуногим, чтобы свести его преимущества к нулю. 
        Бескрылым, почти безглазым (два глаза вместо нескольких сотен); – словом, почти не имеющим шансов на выживание: 
        а вдруг всё-таки нашу шутку раскроют? Пусть она кончится сама собой к следующему прилёту экоинспекции через несколько миллионов лет. 
      </p>
      
      <p class="mb-3">
        Сделали. Улетели.
      </p>
      
      <p class="mb-3">
        Урод, оставленный на Земле, стал развиваться. Новый визит инспекции, через 300 млн. лет, обнаружил интресные вещи: 
        насекомые стали маленькими, а новый тип большим, хотя сначала их планировали примерно одного размера. 
        И те, и другие развили коллективный разум, объединяясь в гигантские сообщества; правда, насекомые делали это при помощи химического, 
        а новый тип – при помощи телепатического взаимодействия. 
        Оба типа заняли всю планету и, в общем, разделили сферы влияния; понемногу, разумеется, каждый из них  пакостил другому, 
        но всё это было в порядке вещей. 
      </p>
      
      <p class="mb-3">
        Совсем не в порядке было то, что среди нового типа выделился ещё один «новый вид», что было совсем не по правилам экоэволюции. 
        Какое-то загрязнение, вероятно, попало в культуру, внесённую в почву, 
        и этот лишний атом или молекула привели к невероятным результатам: отпочковался новый вид, 
        во всём химически и физиологически подобный родительскому, кроме одного: 
        они не могли телепатически соединяться с большинством в коллективный разум.
      </p>
      
      <p class="mb-3">
        Это была не мутация, т.к. те несколько молекул присутствовали в первичной культуре изначально; 
        но почему-то они распределились только среди 0,01 % будущей популяции. 
        Кашлянул, дунул, плюнул кто-то из шутников – кто знает? 
        Ведь как раз «здоровая часть общества оказалась свободной от этой заразы», – как они потом писали о себе. 
      </p>
      
      <p class="mb-3">
        Но факт: некоторые особи упорно не хотели сливаться с большинством. 
        Большинство же, сливаясь в едином порыве, чувствовало их как инородное тело, например, как косточку в супе, и, 
        естественно, желало от них избавиться. 
        Всё это происходило на подсознательном уровне, незаметно для самих себя: вдруг какая-то особь замечала, 
        что она не вписывается в обычные рамки, что её обижают, не замечают…
      </p>
      
      <p class="mb-3">
        Разумеется, в коллективе особей происходило то же, что что в организме каждой отдельной особи: законы эволюции едины для всех. 
        Как при фагоцитозе или пиноцитозе, большинство окружало и выталкивало или уничтожало инородное тело. 
        И чем сильнее это тело сопротивлялось и желало изменить условия окружающей среды – тем сильнее, конечно, среда на него давила.
      </p>
      
      <p class="mb-3">
        В общем, отклонение от правил; – но природа сама справится с ним, – решил новый патруль Экоинспекции. 
        И правда, ещё через 200 млн. лет на этой планете снова остались одни гигантские насекомые. 
        Искусственные вселенцы сгинули, как не бывали. 
        Оказалось, что именно эти инородные тела были активаторами роста и вообще давали энергию развития всей остальной культуре, 
        которая без них скоро состарилась и погибла. 
      </p>
      
      <p class="mb-3">
        Всё это узнали исследователи, заинтересовавшиеся необычным развитием жизни на далёкой планете. 
        Но давно уже не было того первого патруля, решившего пошутить на задворках мира. 
        Наказывать было некого; да и сознательность в Космосе с тех пор неизмеримо возросла.
      </p>
      
      <p class="mb-3">
        Да и в чём, собственно, дело? 
        Порядок-то восстановлен!
      </p>

      <p class="text-center mb-3">КОНЕЦ</p>
        
      
    </div>
    `
  )
}

const itemName = {
  rus: `Петля эволюции`
}


const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;